import React, {useEffect, useState} from 'react';
import {Animated, View, StyleSheet} from "react-native";
import {useSelector} from 'react-redux';
import {getConfig, getCurrentBooking} from "../reducers/configSlice";
import moment from "moment-timezone";
import {EARLY_CHECKIN_DURATION} from "../constants/default";
import moment_tz from "moment-timezone";

const BookingProgressBar = () => {
    const currentBooking = useSelector(getCurrentBooking)
    const config = useSelector(getConfig)
    let interval

    const getProgressStatus = () => {
        if (currentBooking) {
            if (currentBooking.early) {
                const earlyCheckinDuration = EARLY_CHECKIN_DURATION
                const earlyCheckinStart = moment_tz.tz(currentBooking.start, config.timezone).utc().tz(config.timezone).subtract(EARLY_CHECKIN_DURATION, 'minutes')
                const timePassed = moment().tz(config.timezone).diff(earlyCheckinStart, 'minutes')

                return timePassed/earlyCheckinDuration * 100
            }

            const duration = parseInt(currentBooking.duration);
            const durationPassed = moment().tz(config.timezone).diff(moment_tz.tz(currentBooking.start, config.timezone).utc().tz(config.timezone), 'minutes');

            return durationPassed / duration * 100
        }

        return 0
    }

    const [progressStatus, setProgressStatus] = useState(getProgressStatus())

    useEffect( () => {
        if (currentBooking) {
            clearInterval(interval)

            interval = setInterval( () => {
                setProgressStatus(getProgressStatus())
            }, 4000)
        }

        return () => clearInterval(interval);
    }, [currentBooking])

    return (
        currentBooking ?
            <View style={{ height: '2%', width: '30%', borderRadius: 200}}>
                <View style={{backgroundColor: '#29434E', borderRadius: 200}}>
                    <Animated.View
                        style={[styles.inner, {width: progressStatus + "%"}]}
                    />
                </View>
            </View> : null
    );
}

const styles = StyleSheet.create({
    inner:{
        width: "100%",
        height: '100%',
        borderRadius: 200,
        backgroundColor: "#E83948",
    },
});

export default BookingProgressBar;
